import { faArrowAltCircleUp } from '@fortawesome/free-regular-svg-icons';
import { faArrowCircleUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './Footer.css';
import React from 'react';
import { NavHashLink } from 'react-router-hash-link';

const Footer = () => {
    return (
        <div className="home-footer-main-container">
            {/* <FontAwesomeIcon className="footer-icon" icon={faArrowAltCircleUp}/> */}
            <NavHashLink to="/home#home-about"><FontAwesomeIcon className="footer-icon" icon={faArrowCircleUp}/></NavHashLink>
        </div>
    );
};

export default Footer;